import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import Helmet from "react-helmet"
import Header from "../Header/Header"
import { ArticlesApi, FallenAPI } from '../Services/fetchService'
import { apiURL } from "../Services/baseURL"
import { push, vPush } from "../Services/Analytics"
import Loading from "../Services/Loading/Loading"
import ArticleHTML from "./ArticleHTML"
import { fpInit } from "../Services/Flowplayer/player"

// import articles from "../../api/articles.json"
import './Article.scss';
import "./ArticleHeader.scss";

class Article extends Component {
    constructor(props) {
        super();
        this.articleData = this.getArticleData(props.match.params.id);
        this.state = this.getInitialState();
    }
    async getArticleData(id) {
        return await FallenAPI.get(id);
    }
    getInitialState() {
        return {
            articleHtml: '',
            isLoading: true,
            redirect: typeof this.articleData === 'undefined'
        };
    }
    async componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id === this.props.match.params.id) return;
        const data = await this.getArticleData(nextProps.match.params.id);

        this.articleData = data;

        this.setState(this.getInitialState());
        await this.initPage();
    }
    async componentDidMount() {
        const data = await this.getArticleData(this.props.match.params.id);
        this.articleData = data;
        await this.initPage();
    }
    async initPage() {
        if (!this.articleData) return;
        vPush((window.location.href).replace(window.location.origin,"") + "?prof=2.News-Fallen", this.articleData.FullName);
        const _articleHtml = await ArticlesApi.get(this.articleData.ArticleID);

        this.setState({
            articleHtml: _articleHtml,
            isLoading: false
        });
        window.scrollTo(0, 0);

        if (this.articleData.videoId) {
            const details = await ArticlesApi.getVideoDetails(this.articleData.videoId);
            if (details && details.length)
                this.initVideo(details[0])
        }
    }
    initVideo(details) {
        fpInit(Object.assign({}, details, { selector: "#video" }));
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={{ pathname: '/' }} />
            )
        }
        return (
            <div>
                <Header isArticle={true} />
                <div className="article">
                    <section className="section section-article">
                        <Helmet>
                            {/* <title>זיכרון אחרון - {this.props.match.params.id}</title> */}
                            <title>זיכרון אחרון</title>
                        </Helmet>
                        <div className="padding">
                            <div className="container">
                                <Loading showLoading={this.state.isLoading} />
                                <ArticleHTML html={this.state.articleHtml} />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/Article/Article.jsx